import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { addOrganization } from "@redux/actions/organizations-actions";
import { createAxnCompanyRequest } from "@requests/axnadmin-core";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const createOrganizationReduxRequest = (dispatch: Dispatch) => async (name: string, companyCode: string, customerSupportTierUID: string): Promise<AxnCompany> => {
    const { data, error, body } = await createAxnCompanyRequest(name, companyCode, customerSupportTierUID);
    if (data?.response) {
        dispatch(addOrganization({
            ...data.response,
            permissions: {
                canArchive: true,
                canDelete: true,
                canModify: true,
                canRestore: true,
                canView: true
            }
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.createOrganization.success.title,
            resources.requests.createOrganization.success.message
        );
        return data.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createOrganization.error.title,
            resources.requests.createOrganization.error.message,
            null,
            null,
            body
        );
    }

    return null;
};